import { render, staticRenderFns } from "./FbStarRating.vue?vue&type=template&id=5f25dc86&scoped=true"
import script from "./FbStarRating.vue?vue&type=script&lang=js"
export * from "./FbStarRating.vue?vue&type=script&lang=js"
import style0 from "./FbStarRating.vue?vue&type=style&index=0&id=5f25dc86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f25dc86",
  null
  
)

export default component.exports